import React, {Component, PropTypes} from 'react'
import cs from 'classnames'
import styles from './ScrollTop.scss'

class ScrollTop extends Component {

	componentDidUpdate() {
		this.me.scrollTop = 0
	}

	render() {
		return (
			<div
				{...this.props}
				className={cs(styles.cont, this.props.className)}
				ref={el => this.me = el}
			/>
		)
	}
}

ScrollTop.propTypes = {
	children: PropTypes.node,
}

export default ScrollTop



// WEBPACK FOOTER //
// ./elements/ScrollTop.jsx